export default __webpack_public_path__ + "static/media/A3.d5fb8b53.png";